import { Component, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import {
  CategoryItem,
  ContactItem,
  CurrencyModel,
  TransactionTypeEnum,
  OutlineItem,
} from '../../models/base.models';
import { ApiService } from '../../services/api.service';
import { Subscription, lastValueFrom } from 'rxjs';

@Component({
  selector: 'formly-field-system-transaction-contact',
  encapsulation: ViewEncapsulation.None,
  styles: [
    `
      .child-value-container {
        padding-left: 2.5rem !important;
      }
      .ng-value-label .child-value-container {
        padding-left: 0 !important;
      }
    `,
  ],
  template: `
  <div *ngIf="!loaded; else fieldContainer">
  <div class="spinner-border text-primary" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>

<ng-template #fieldContainer>
    <div class="mb-3">
      <label class="form-label" [for]="field.id">
      {{ field.props.label }}
        <span *ngIf="field.props.required" aria-hidden="true">*</span></label
      >
      <ng-select
        class="ng-select-solid"
        [ngClass]="{ 'is-invalid': formControl.invalid && formControl.touched }"
        [labelForId]="field.id"
        [placeholder]="field.props.placeholder"
        [editableSearchTerm]="false"
        [clearSearchOnAdd]="false"
        [clearable]="false"
        type="input"
        [multiple]="false"
        [formControl]="formControl"
      >
        <ng-container *ngFor="let contact of contactsList; let i = index">
          <ng-option [value]="contact.id">
            <span class="d-flex align-items-center">
            <div class="symbol symbol-35px me-2">
                  <span class="symbol-label border"
                    ><img
                    *ngIf="!!contact.avatar"
                      class="w-75 align-self-center"
                      src="{{ contact.avatar }}"
                  />

                  <span
                  *ngIf="!contact.avatar"
                  >{{ contact.firstname[0] }}</span
                >
                </span>
                </div>

              <span>
                {{ contact.firstname }} {{contact.lastname}}
              </span>
            </span>
          </ng-option>

        </ng-container>
      </ng-select>
    </div>
</ng-template>
  `,
})
export class systemTransactionContactFieldType
  extends FieldType<FieldTypeConfig>
  implements OnInit, OnDestroy
{
  loaded: boolean = true;
  contactsList: ContactItem[] = [];
  currentSpaceId: number;

  currentTransactionType: TransactionTypeEnum = TransactionTypeEnum.expense;

  subscriptions: Subscription[] = []
  constructor(private api: ApiService) {
    super();
  }




  ngOnDestroy(): void {
    this.formControl?.reset();
  }


  async ngOnInit() {
    
    this.currentSpaceId = +this.field.props.attributes['space_id'];
    this.contactsList = await this.getSpaceContacts(this.currentSpaceId);
    // this.loaded = true;
    // await this.watchControlChange()
  }

  async getSpaceContacts(spaceId: number = this.currentSpaceId, type: TransactionTypeEnum = this.currentTransactionType) {
    let request$ = this.api.getSpaceContacts(spaceId);
    let response = await lastValueFrom(request$);


    return response;
  }

  async watchControlChange() {


  }
}
